import { Button, EmptyState } from '../../components/ui';
import Turno from './Turno';
import './MisTurnos.css';

export default function ProximosTurnos({ proximos, onCancel }) {
  return (
    <section className="mis-turnos-section">
      <h2>Próximos turnos</h2>
      {proximos.length === 0 ? (
        <EmptyState
          title="No hay turnos próximos"
          action={<Button to="/buscar" size="sm">Reservar un turno</Button>}
        />
      ) : (
        <div className="mis-turnos-grid">
          {proximos.map((turno) => (
            <Turno
              key={turno.id}
              turno={turno}
              onCancel={onCancel}
              showCancel
            />
          ))}
        </div>
      )}
    </section>
  );
}